module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-module-properties-input"
  }, _vm._l((_vm.props), function(code) {
    return _c('div', {
      key: ("prices-settings-field-" + code),
      staticClass: "z-module-properties-input__item"
    }, [(_vm.localValue[code] && (['text', 'number'].indexOf(_vm.localValue[code].type) + 1)) ? _c('z-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      attrs: {
        "type": _vm.localValue[code].type,
        "name": _vm.localValue[code].code,
        "label": _vm.localValue[code].name,
        "placeholder": _vm.localValue[code].placeholder,
        "error": _vm.errors.first(_vm.localValue[code].code),
        "data-vv-name": _vm.localValue[code].code,
        "data-vv-as": ' ',
        "required": true
      },
      model: {
        value: (_vm.localValue[code].value),
        callback: function($$v) {
          _vm.$set(_vm.localValue[code], "value", $$v)
        },
        expression: "localValue[code].value"
      }
    }) : (_vm.localValue[code] && _vm.localValue[code].type == 'select') ? _c('z-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      attrs: {
        "name": _vm.localValue[code].code,
        "label": _vm.localValue[code].name,
        "error": _vm.errors.first(_vm.localValue[code].code),
        "data-vv-name": _vm.localValue[code].code,
        "data-vv-as": ' ',
        "required": true
      },
      model: {
        value: (_vm.localValue[code].value),
        callback: function($$v) {
          _vm.$set(_vm.localValue[code], "value", $$v)
        },
        expression: "localValue[code].value"
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v(_vm._s(_vm.localValue[code].placeholder || 'Укажите значение'))]), _vm._v(" "), _vm._l((_vm.localValue[code].values), function(label, value) {
      return _c('option', {
        key: ("prices-settings-field-" + code + "-select-" + value),
        domProps: {
          "value": value
        }
      }, [_vm._v(_vm._s(label))])
    })], 2) : (_vm.localValue[code] && _vm.localValue[code].type == 'checkbox' && _vm.localValue[code].multiply) ? _c('ZCheckList', {
      staticClass: "z-module-properties-input__item-container",
      attrs: {
        "label": _vm.localValue[code].name
      }
    }, _vm._l((_vm.localValue[code].values), function(label, value) {
      return _c('z-check', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ({}),
          expression: "{}"
        }],
        key: ("z-module-prop-input-" + (_vm.localValue[code].code) + "-" + value),
        attrs: {
          "value": value,
          "label": label,
          "name": ((_vm.localValue[code].code) + "-" + value),
          "error": _vm.errors.first(((_vm.localValue[code].code) + "-" + value)),
          "data-vv-name": ((_vm.localValue[code].code) + "-" + value),
          "data-vv-as": ' '
        },
        model: {
          value: (_vm.localValue[code].value),
          callback: function($$v) {
            _vm.$set(_vm.localValue[code], "value", $$v)
          },
          expression: "localValue[code].value"
        }
      })
    })) : _vm._e(), _vm._v(" "), (_vm.localValue[code] && _vm.localValue[code].help) ? _c('div', {
      staticClass: "z-module-properties-input__description",
      domProps: {
        "innerHTML": _vm._s(_vm.localValue[code].help)
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97c81f9a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZModulePropertiesInput.vue
// module id = 1222
// module chunks = 0